let mutations = {
    setShuerte(state, data) {
        state.shuerteGame = data;
    },
    setAttentionGame(state, data) {
        state.attentionGame = data;
    },
    setSheepGame(state, data) {
        state.findSheepGame = data;
    },
    setRankGame(state, data) {
        state.rankGame = data;
    },
    setRegulaGame(state, data) {
        state.regulaGame = data;
    },
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/sevenAbilityGames/mutations.js